import autobind from 'core-decorators/lib/autobind';

import WixSDK from 'shared/utils/wix-sdk';

import attachScript from 'widget/player-widget/utils/attach-script';
import { stringify } from 'shared/utils/query-string';


const locale = WixSDK.Utils.getLocale();


const scriptApiUrl = 'https://www.youtube.com/iframe_api';
let scriptPromise = null;


export default class YoutubeExternal extends React.Component {

  static propTypes = {
    src: React.PropTypes.string.isRequired,
    onPlay: React.PropTypes.func,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    className: React.PropTypes.string,
    simple: React.PropTypes.bool,
    mobileMode: React.PropTypes.bool,
    showControls: React.PropTypes.bool,
    paused: React.PropTypes.bool,
    loop: React.PropTypes.bool,
    muted: React.PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.player = null;

    this.state = {
      isReady: false,
    };
  }

  componentDidMount() {
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;

    // load once
    if (this.isScriptLoaded) {
      this.onYouTubeIframeAPIReady();
    } else if (!scriptPromise) {
      scriptPromise = attachScript(scriptApiUrl);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src === this.props.src) {
      this.setSettings(nextProps, this.props);
    } else {
      this.setState({ isReady: false });
    }
  }

  componentWillUnmount() {
    window.onYouTubeIframeAPIReady = null;
  }

  get isScriptLoaded() {
    return _.has(window, 'YT.Player');
  }

  @autobind
  onYouTubeIframeAPIReady() {
    void new window.YT.Player(this.iframe, {
      events: {
        onReady: this.onReady,
      },
    });
  }

  @autobind
  onReady({ target }) {
    this.player = target;
    this.setState({ isReady: true });
    this.setSettings(this.props);
  }

  setSettings({ paused, loop, muted }, prevProps = {}) {
    if (!this.player || !this.state.isReady) {
      return null;
    }

    if (prevProps.paused !== paused) {
      this.togglePaused(paused);
    }

    this.toggleLoop(loop);
    this.toggleMute(muted);
  }

  togglePaused(paused) {
    if (paused) {
      this.player.pauseVideo();
    } else {
      this.player.playVideo();
    }
  }

  toggleLoop(loop) {
    if (loop) {
      const { video_id } = this.player.getVideoData();
      // need load playlist to set loop to true
      // but loadPlay list sets video to the beginning
      this.player.loadPlaylist(video_id);
      this.player.setLoop(true);
    } else {
      this.player.setLoop(false);
    }
  }

  toggleMute(muted) {
    if (muted) {
      this.player.mute();
    } else {
      this.player.unMute();
    }
  }

  buildUrl({ src, simple, mobileMode, showControls }) {
    const { protocol, hostname, port } = window.location;

    const origin = `${protocol}//${hostname}${port ? ':' : ''}${port}`;

    const query = {
      enablejsapi: '1',
      hl: locale,
      rel: '0',
      origin,
    };

    if (simple || mobileMode) {
      query.showinfo = '0';
    }
    if (mobileMode) {
      query.playsinline = '0';
    }
    if (!showControls) {
      query.controls = '0';
    }

    return `${src}${stringify(query)}`;
  }

  render() {
    const props = _.pick(this.props, 'className', 'width', 'height');

    return (
      <iframe {...props}
              src={this.buildUrl(this.props)}
              frameBorder="0"
              allowFullScreen
              ref={node => (this.iframe = node)} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/video/external/youtube.js